<template lang="pug">
  #appHeader.d-flex.align-items-center.main_header_title(:style="cusStyle")
    i.fas.fa-chevron-left.fa-lg.icon-back(
      v-if="hasBackTool",
      @click="backHandler()"
    )
    b-img.logo.py-2(
      fluid,
      :src="'xxx'",
      alt="logo",
      :onerror="defaultLogo",
      v-if="headerType === 'logo'"
    )
    h5.mb-0.ml-1(
      v-if="headerType === 'title'"
    ) {{ title }}
    slot(name="extra-area")
</template>

<script>

import defaultLogoUrl from '@/assets/images/logo/logo.png';

export default {
  name: 'appHeader',
  props: {
    cusStyle: {
      type: Object,
      default: () => ({})
    },
    hasBackTool: {
      type: Boolean,
      default: false
    },
    headerType: {
      type: String,
      default: 'logo'
    },
    title: {
      type: String,
      default: null
    },
    targetRouterName: {
      type: String,
      default: null
    },
    targetRouterParams: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      defaultLogo: `this.src="${defaultLogoUrl}"`
    };
  },
  methods: {
    backHandler() {
      const vm = this;
      if (vm.targetRouterName) {
        const targetInfo = {
          name: vm.targetRouterName,
          params: vm.targetRouterParams
        };
        if (!vm.targetRouterParams) {
          delete targetInfo.params;
        }
        vm.$router.push(targetInfo);
      } else {
        vm.$router.go(-1);
      }
    }
  }
};
</script>

<style scoped>
  #appHeader {
    justify-content: center;
    padding: 16px 32px;
  }

  .logo {
    width: 52%;
    z-index: 2;
    max-width: 200px;
  }

  .top {
    background-color: #000 !important;
    width: 100%;
    border-radius: 0 0 1rem 1rem;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    height: 10rem;
  }

</style>
